export default function Activity() {
    return <h2>Activity Logs</h2>;
}